import { useParams } from 'react-router-dom';
import { useState } from 'react';
import { GroupQuestionsDisplay } from '@/components/assessment/GroupQuestionsDisplay';
import { GroupProgressBreadcrumb } from '@/components/assessment/GroupProgressBreadcrumb';
import { SimulateNavigation } from '@/components/assessment/SimulateNavigation';
import { useAssessmentSimulation } from '@/hooks/useAssessmentSimulation';
import { useAuthorization } from '@/hooks/useAuthorization';

export default function SimulateAssessmentPage() {
  const { jobPositionId } = useParams<{ jobPositionId: string }>();
  const { hasPermission, loading } = useAuthorization();
  const canRead = hasPermission('job_positions.read');
  const { questionGroups, questionsByGroup, isLoading, error } =
    useAssessmentSimulation(canRead ? jobPositionId : undefined);
  const [currentGroupIndex, setCurrentGroupIndex] = useState(0);

  if (loading || isLoading) return <div className="p-4">Loading...</div>;
  if (!canRead) return <div className="p-4">You do not have permission to view this page.</div>;
  if (!jobPositionId) return <div className="p-4">Invalid job position.</div>;
  if (error) return <div className="p-4 text-red-500">Error loading assessment.</div>;
  if (questionGroups.length === 0)
    return <div className="p-4">No question groups configured.</div>;

  const currentGroup = questionGroups[currentGroupIndex];
  const questions = questionsByGroup[currentGroup.id] || [];

  const handleNext = () => {
    if (currentGroupIndex < questionGroups.length - 1) {
      setCurrentGroupIndex((i) => i + 1);
    }
  };
  const handlePrevious = () => {
    if (currentGroupIndex > 0) {
      setCurrentGroupIndex((i) => i - 1);
    }
  };

  return (
    <div className="space-y-6 p-4">
      <h1 className="text-2xl font-bold">Assessment Simulation</h1>
      {questionGroups.length > 1 && (
        <GroupProgressBreadcrumb
          questionGroups={questionGroups}
          currentGroupIndex={currentGroupIndex}
        />
      )}
      <div className="bg-white rounded-lg shadow p-6">
        <GroupQuestionsDisplay
          questions={questions}
          responses={{}}
          onAnswerChange={() => {}}
          onOptionSelect={() => {}}
          groupName={currentGroup.name}
        />
      </div>
      <SimulateNavigation
        currentGroupIndex={currentGroupIndex}
        totalGroups={questionGroups.length}
        canGoPrevious={currentGroupIndex > 0}
        canGoNext={currentGroupIndex < questionGroups.length - 1}
        onPrevious={handlePrevious}
        onNext={handleNext}
        isLast={currentGroupIndex === questionGroups.length - 1}
      />
    </div>
  );
}
